import { render, staticRenderFns } from "./proof-points.vue?vue&type=template&id=42ed96ff"
import script from "./proof-points.vue?vue&type=script&lang=js"
export * from "./proof-points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports